import * as R from "ramda"
import {connect, Store} from "react-redux";
import {compose, Dispatcher, DispatcherActionLike} from "../../../lib/utils";
import {Action} from "redux";
import {CallbackProps, QueryFormModal, ValueProps} from "./presentation";
import {QueryFormAction, QueryFormActionWrapper} from "./actions";
import {CommandCaller} from "../../../lib/commands";
import {
	categoryManagerMapDispatchToProps,
	categoryManagerMapStateToProps, CategoryManagerOwnProps,
} from "../../../lib/category-manager/app";
import {State} from "./reducers";
import {ErrorField} from "./data";
import {CategoryId} from "../../../lib/category-manager/data";

export type QueryFormStore = Store<State>

export type OwnProps = CategoryManagerOwnProps & {
	store: QueryFormStore,
	ajaxPageUrl: string
	onClose: () => void
}

const mapStateToProps = (state: State, ownProps: OwnProps): ValueProps => {
	return {
		...R.omit(['queryId', 'categoryManagerState'], state),
		categoryManagerValueProps: categoryManagerMapStateToProps(state.categoryManagerState, ownProps)
	}
}

const mapDispatchToProps = (dispatch: Dispatcher<Action, State>, ownProps: OwnProps): CallbackProps => {
	const wrap = (action: QueryFormAction): QueryFormActionWrapper => ({
		type: "query form action",
		action
	})
	const dispatchAction = compose<QueryFormAction, QueryFormActionWrapper, Action>(wrap, dispatch)
	return {
		setTitle: (title) => dispatchAction({type: "set title", title}),
		setSubmitting: (submitting) => dispatchAction({type: "set submitting", submitting}),
		onCancel: ownProps.onClose,
		onSave: () => dispatch(saveQueryAction(dispatchAction, ownProps)),
		categoryManagerCallbackProps: categoryManagerMapDispatchToProps(dispatch)
	}
}

const saveQueryAction = (dispatchWrapped: DispatcherActionLike<QueryFormAction, Action>, ownProps: OwnProps) => async (dispatchUnwrapped: DispatcherActionLike<Action, void>, getState: () => State) => {
	dispatchWrapped({type: "set submitting", submitting: true})

	const state = getState();
	try {
		const queryId = state.queryId
		const command = queryId > 0 ? 'save query' : 'create query'
		const r = await new CommandCaller(ownProps.ajaxPageUrl).runPost(
			command,
			commandParams(command, state)
		) as {errorFields: ErrorField[]}
		if(r.errorFields.length == 0) {
			ownProps.onClose()
		} else {
			dispatchWrapped({type: 'set failure', errorFields: r.errorFields})
		}
	} catch (e) {
		window.alert("There was an unexpected error. Ensure you're logged in, your internet connection is working, and try reloading the page")
	}

	dispatchWrapped({type: "set submitting", submitting: false})
}

type SaveCommand = 'create query'|'save query'
type SaveCommandParams = NewParams | EditParams
type NewParams = {
	title: string
	categories: CategoryId[]
}
type EditParams = {
	queryId: CategoryId
	title: string
	categories: CategoryId[]
}
const commandParams = (ct: SaveCommand, state: State): SaveCommandParams => {
	const selectedCategories = state.categoryManagerState.selectedCategories
	switch (ct) {
		case 'create query':
			return {
				title: state.title,
				categories: selectedCategories
			}
		case 'save query':
			return {
				queryId: +state.queryId,
				title: state.title,
				categories: selectedCategories
			}
	}
}

export const QueryFormModalApp = connect<ValueProps, CallbackProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps
)(QueryFormModal)



// WEBPACK FOOTER //
// ./src/contacts/saved-queries/query-form/app.ts